import style from "./CustomModelNumbersIcon.module.scss"

export const CustomModelNumbersIcon = () => {
	return (
		<span className={style.icon} aria-hidden="true">
			<span>01</span>
			<span>10</span>
		</span>
	)
}
